import { defineMessages } from 'react-intl';

export default defineMessages({
    downloadError: {
        id: 'twia.fnol.common.views.Unable to download file',
        defaultMessage: 'Unable to download file, please check back later',
    },
    filenameTooLong: {
        id: 'twia.fnol.common.views.Filname too long',
        defaultMessage: 'File names cannot exceed 60 characters, including the extension. Please shorten the file name and try again.',
    }
})
